// Get base environment from build variable
const baseEnvironment = import.meta.env.VITE_API_ENVIRONMENT || "production";

// Function to get effective environment (checks for override first)
const getEffectiveEnvironment = () => {
  // Check if there's a runtime override in localStorage
  const override = localStorage.getItem('environment_override');
  if (override) {
    return override;
  }
  return baseEnvironment;
};

const config = {};
const googleMapsApiKey = "AIzaSyDyBiZQPXSTPxaOtFIQwpbtWM9Evsk524k";

const nodes = [0,1,2].map((i) => {
  return {
    host: `search-${i}.saucey-api2.com`,
    protocol: "https" 
  }
})

config["local-ip"] = {
  googleMapsApiKey,
  // Raw retailer FTP drop bucket (MenuService aws.s3.bucket["raw-ftp"]).
  ftpBucket: "saucey-dev-menu-ftp",
  awsRegion: "us-west-2",
  environment: "local-ip",
  vpnCheck: "http://192.168.1.216:1234/ping",
  ms: "http://192.168.1.216:1234",
  vpnMs: "http://192.168.1.216:1234",
  os: "http://192.168.1.216:1235",
  vpnOs: "http://192.168.1.216:1235",
  manageAPI: "http://192.168.1.216:8080",
  vpnManageAPI: "http://192.168.1.216:8081",
  socket: "ws://192.168.1.216:1235",
  direct_web_prefix: "http://192.168.1.216:3000/shop/",
  ts: {
    index: "development_products",
    nodes,
    nearestNode: {
      host: "search.saucey-api2.com",
      protocol: "https"
    },
    key: "ml9xXtMniuEEPU2gAADZKHT2qv5CLsem",
  },
  stripe: {
    pk: "pk_test_CVQaS9J2i5sqylQ0M3ApDQyz",
    subscriptionPK: "pk_test_51RQsz44QGz2J90Z8b01ZUxtKFJwTjbu2bW1LY3v7FveKyS2P7cu2BPd3mg2uUY3jnUvda1SqmKVfuIViVCKRDLiJ00OhIYrbSu"
  },
  clover: {
    clientId: "YOUR_CLOVER_CLIENT_ID",
    clientSecret: "YOUR_CLOVER_CLIENT_SECRET",
    authUrl: "https://sandbox.dev.clover.com/oauth/authorize",
    tokenUrl: "https://sandbox.dev.clover.com/oauth/token",
    apiBaseUrl: "https://sandbox.dev.clover.com/v3"
  },
};
config["local"] = {
  googleMapsApiKey,
  // Raw retailer FTP drop bucket (MenuService aws.s3.bucket["raw-ftp"]).
  ftpBucket: "saucey-dev-menu-ftp",
  awsRegion: "us-west-2",
  environment: "development",
  vpnCheck: "https://menu.internal.saucey.com/ping",
  ms: "http://localhost:1234",
  vpnMs: "http://localhost:1234",
  os: "http://localhost:1235",
  vpnOs: "http://localhost:1235",
  manageAPI: "http://localhost:8080",
  vpnManageAPI: "http://localhost:8080",
  socket: "ws://localhost:1235",
  direct_web_prefix: "http://localhost:3000/shop/",
  ts: {
    index: "development_products",
    nodes,
    nearestNode: {
      host: "search.saucey-api2.com",
      protocol: "https"
    },
    key: "ml9xXtMniuEEPU2gAADZKHT2qv5CLsem",
  },
  stripe: {
    pk: "pk_test_CVQaS9J2i5sqylQ0M3ApDQyz",
    subscriptionPK: "pk_test_51RQsz44QGz2J90Z8b01ZUxtKFJwTjbu2bW1LY3v7FveKyS2P7cu2BPd3mg2uUY3jnUvda1SqmKVfuIViVCKRDLiJ00OhIYrbSu"
  },
  clover: {
    clientId: "YOUR_CLOVER_CLIENT_ID",
    clientSecret: "YOUR_CLOVER_CLIENT_SECRET",
    authUrl: "https://www.clover.com/oauth/authorize",
    tokenUrl: "https://sandbox.dev.clover.com/oauth/token",
    apiBaseUrl: "https://sandbox.dev.clover.com/v3"
  },
};
config["development"] = {
  googleMapsApiKey,
  // Raw retailer FTP drop bucket (MenuService aws.s3.bucket["raw-ftp"]).
  ftpBucket: "saucey-dev-menu-ftp",
  awsRegion: "us-west-2",
  environment: "development",
  vpnCheck: "https://menu.internal.saucey.com/ping",
  ms: "https://menu.dev-saucey-api2.com",
  vpnMs: "https://menu.dev-saucey-api2.com",
  os: "https://order.dev-saucey-api2.com",
  vpnOs: "https://order.dev-saucey-api2.com",
  manageAPI: "https://mgmt.dev-saucey-api2.com",
  vpnManageAPI: "https://mgmt.dev-saucey-api2.com",
  socket: "wss://order.dev-saucey-api2.com",
  direct_web_prefix: "https://direct-dev.saucey.com/shop/",
  ts: {
    index: "development_products",
    nodes,
    nearestNode: {
      host: "search.saucey-api2.com",
      protocol: "https"
    },
    key: "ml9xXtMniuEEPU2gAADZKHT2qv5CLsem",
  },
  stripe: {
    pk: "pk_test_CVQaS9J2i5sqylQ0M3ApDQyz",
    subscriptionPK: "pk_test_51RQsz44QGz2J90Z8b01ZUxtKFJwTjbu2bW1LY3v7FveKyS2P7cu2BPd3mg2uUY3jnUvda1SqmKVfuIViVCKRDLiJ00OhIYrbSu"
  },
  clover: {
    clientId: "YOUR_CLOVER_CLIENT_ID",
    clientSecret: "YOUR_CLOVER_CLIENT_SECRET",
    authUrl: "https://sandbox.dev.clover.com/oauth/authorize",
    tokenUrl: "https://sandbox.dev.clover.com/oauth/token",
    apiBaseUrl: "https://sandbox.dev.clover.com/v3"
  },
};
config["production"] = {
  googleMapsApiKey,
  // Raw retailer FTP drop bucket (MenuService aws.s3.bucket["raw-ftp"]).
  ftpBucket: "saucey-menu-ftp",
  awsRegion: "us-west-2",
  environment: "production",
  vpnCheck: "https://menu.internal.saucey.com/ping",
  ms: "https://menu-service.sauceydirect.com",
  vpnMs: "https://menu.internal.saucey.com",
  os: "https://order-service.sauceydirect.com",
  vpnOs: "https://order.internal.saucey.com",
  manageAPI: "https://manage-api.sauceydirect.com",
  vpnManageAPI: "https://manage-api.internal.saucey.com",
  socket: "wss://order-service.sauceydirect.com",
  direct_web_prefix: "https://direct.saucey.com/shop/",
  ts: {
    index: "production_products",
    nodes,
    nearestNode: {
      host: "search.saucey-api2.com",
      protocol: "https"
    },
    key: "ml9xXtMniuEEPU2gAADZKHT2qv5CLsem",
  },
  stripe: {
    pk: "pk_live_2gtHRpyPXozK7dgX2Yce0OMC",
    subscriptionPK: "pk_live_51RQsyyGCH2K8gYzHJyyguU0NyQwKXZu7YOEAKsD7hlxIdnkFZYPlu01gUJ0Cbg0DUbEoMGU2BYSz369clCAig5zA002sVxwxkp"
  },
  clover: {
    clientId: "YOUR_CLOVER_CLIENT_ID",
    clientSecret: "YOUR_CLOVER_CLIENT_SECRET",
    authUrl: "https://www.clover.com/oauth/authorize",
    tokenUrl: "https://www.clover.com/oauth/token",
    apiBaseUrl: "https://api.clover.com/v3"
  },
};

// Helper functions to manage environment override
export const setEnvironmentOverride = (env) => {
  if (env && config[env]) {
    localStorage.setItem('environment_override', env);
    return config[env];
  }
  return config[getEffectiveEnvironment()];
};

export const clearEnvironmentOverride = () => {
  localStorage.removeItem('environment_override');
};

export const getCurrentEnvironment = () => {
  return getEffectiveEnvironment();
};

export const getCurrentConfig = () => {
  return config[getEffectiveEnvironment()];
};

// Create a Proxy that dynamically returns properties from the effective config
const configProxy = new Proxy({}, {
  get(target, prop) {
    const currentConfig = config[getEffectiveEnvironment()];
    return currentConfig[prop];
  }
});

export default configProxy;

// Export the async function for runtime environment detection
